// extracted by css-extract-rspack-plugin
export default {"trigger":"JL6clTuXWGwAGhGx","snackbar":"jBJxcjCFSa0Cko2l","dialogList":"TAJzWWMdDVUPR286"};